/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_METRICS,
  SET_DATE_RANGE,
  FETCH_AGENT_AVAILABILITY_METRICS_REQUEST,
  FETCH_AGENT_AVAILABILITY_METRICS_SUCCESS,
  FETCH_AGENT_AVAILABILITY_METRICS_FAILURE
} from 'src/actions/analyticsActions';

const initialState = {
  metrics: [],
  prevPeriod: [],
  dateRange: {
    value: 'this_week',
    text: 'This week'
  },
  agentAvailability: {
    data: [],
    loading: false,
    error: null
  }
};

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_METRICS: {
      const { metrics, prevPeriod } = action.payload;

      return produce(state, draft => {
        draft.metrics = metrics;
        draft.prevPeriod = prevPeriod;
      });
    }
    case SET_DATE_RANGE: {
      const { dateRange } = action.payload;

      return produce(state, draft => {
        draft.dateRange = dateRange;
      });
    }

    case FETCH_AGENT_AVAILABILITY_METRICS_REQUEST: {
      return produce(state, draft => {
        draft.agentAvailability.loading = true;
        draft.agentAvailability.error = null;
      });
    }

    case FETCH_AGENT_AVAILABILITY_METRICS_SUCCESS: {
      return produce(state, draft => {
        draft.agentAvailability.data = action.payload;
        draft.agentAvailability.loading = false;
        draft.agentAvailability.error = null;
      });
    }

    case FETCH_AGENT_AVAILABILITY_METRICS_FAILURE: {
      return produce(state, draft => {
        draft.agentAvailability.loading = false;
        draft.agentAvailability.error = action.payload;
      });
    }

    default: {
      return state;
    }
  }
};

export default analyticsReducer;
